import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=2b50b039&scoped=true&"
import script from "./ProjectItem.vue?vue&type=script&lang=js&"
export * from "./ProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&id=2b50b039&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50b039",
  null
  
)

export default component.exports